/* tslint:disable */
/* eslint-disable */
/**
 * Core Api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';

import type { AdminDataWorkOpenAccessFundedDTO } from './AdminDataWorkOpenAccessFundedDTO';
import {
    AdminDataWorkOpenAccessFundedDTOFromJSON,
    AdminDataWorkOpenAccessFundedDTOFromJSONTyped,
    AdminDataWorkOpenAccessFundedDTOToJSON,
    AdminDataWorkOpenAccessFundedDTOToJSONTyped,
} from './AdminDataWorkOpenAccessFundedDTO';

/**
 * 
 * @export
 * @interface AdminDataWorkOpenAccessDTO
 */
export interface AdminDataWorkOpenAccessDTO  {
    /**
     * 
     * @type {number}
     * @memberof AdminDataWorkOpenAccessDTO
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof AdminDataWorkOpenAccessDTO
     */
    accessLevel?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminDataWorkOpenAccessDTO
     */
    articleProcessingCharge?: string;
    /**
     * 
     * @type {Array<AdminDataWorkOpenAccessFundedDTO>}
     * @memberof AdminDataWorkOpenAccessDTO
     */
    adminDataWorkOpenAccessFundeds?: Array<AdminDataWorkOpenAccessFundedDTO>;
}

/**
 * Check if a given object implements the AdminDataWorkOpenAccessDTO interface.
 */
export function instanceOfAdminDataWorkOpenAccessDTO(value: object): value is AdminDataWorkOpenAccessDTO {
    return true;
}

export function AdminDataWorkOpenAccessDTOFromJSON(json: any): AdminDataWorkOpenAccessDTO {
    return AdminDataWorkOpenAccessDTOFromJSONTyped(json, false);
}

export function AdminDataWorkOpenAccessDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): AdminDataWorkOpenAccessDTO {
    if (json == null) {
        return json;
    }
    return {
        
                  'id': json['id'] == null ? undefined : json['id'],
                  'accessLevel': json['accessLevel'] == null ? undefined : json['accessLevel'],
                  'articleProcessingCharge': json['articleProcessingCharge'] == null ? undefined : json['articleProcessingCharge'],
              'adminDataWorkOpenAccessFundeds': json['adminDataWorkOpenAccessFundeds'] == null ? undefined : ((json['adminDataWorkOpenAccessFundeds'] as Array<any>).map(AdminDataWorkOpenAccessFundedDTOFromJSON)),
    };
}

export function AdminDataWorkOpenAccessDTOToJSON(json: any): AdminDataWorkOpenAccessDTO {
    return AdminDataWorkOpenAccessDTOToJSONTyped(json, false);
}

export function AdminDataWorkOpenAccessDTOToJSONTyped(value?: AdminDataWorkOpenAccessDTO | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'accessLevel': value['accessLevel'],
        'articleProcessingCharge': value['articleProcessingCharge'],
        'adminDataWorkOpenAccessFundeds': value['adminDataWorkOpenAccessFundeds'] == null? value['adminDataWorkOpenAccessFundeds']: (value['adminDataWorkOpenAccessFundeds'] as Array<any>).map(AdminDataWorkOpenAccessFundedDTOToJSON),
    };
}


